import React, {Fragment, useRef, useState,useEffect} from "react";
import {MobCard} from "../components/MobCard";
import {MobEditButton} from "../components/MobEditButton";
import {MobAddButton} from "../components/MobAddButton";
import {Trans} from "@lingui/react/macro";
import {DynamicIcon} from "lucide-react/dynamic";
import {Popover} from "antd-mobile";
import {contactCopie} from "./functions";
import ModalAddField from "../../views/app-views/contact/ModalAddField";
import {useActionSheet} from "../providers/ActionSheetProvider";
import {t} from "@lingui/core/macro"
import {notification, Tag} from "antd";
import {MobEditButtonIcon} from "../components/MobEditButtonIcon";
import {checkForfait, checkPermissions} from "../../components/permissions/functions";
import IntlMessage from "../../components/util-components/IntlMessage";
import ApiService from "../../services/ApiService";
import ModalAddTag from "../../views/app-views/contact/ModalAddTag";
import {MOBCOLORS} from "../../configs/AppConfig";

export default function ContactTabSecondary({selected}){

    return(
        <div style={{display:"flex",flexDirection:"column",gap:30,paddingTop:20}}>
            <CardCategories selected={selected}/>
            <CardInfos selected={selected}/>
        </div>
    )
}


function CardCategories({selected})
{
    const modalAddTag=useRef(null)
    const actionSheetManager=useActionSheet()
    const [showMore, setShowMore] = useState(selected.categories?.length<=3)


    const onRemoveTag=async(tag)=>{
        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }
        var res = await ApiService.post("/contact/removetag/" + selected.id, {tag: tag})
        console.log(res)

        if (res.success) {
            notification.success({
                message: <IntlMessage id="success.delete"/>
            })

            await selected.__refreshData()
        } else {
            notification.success({
                message: <IntlMessage id="error.delete"/>
            })
        }
    }

    let categories=selected.categories || []
    if(!showMore){
        categories=categories.slice(0,3)
    }

    return(
        <>
            <div style={{display: "flex", flexDirection: "column", gap: 10}}>

                <div style={{display:"flex",alignSelf:"flex-end"}}>
                    <MobAddButton text={(<Trans>Ajouter ce contact à une categorie</Trans>)} onClick={()=>modalAddTag.current.show([selected.id],selected.categories)}/>
                </div>

                {selected.categories?.length>0 &&(
                    <>
                        <MobCard style={{boxShadow: "none", position: "relative",paddingBottom:30,paddingTop:15}}>
                            <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", rowGap: 10}}>
                                {categories.map(item => {
                                    return (
                                        <Tag style={{cursor: "pointer"}} key={item} color={"red"} onClick={()=>{
                                            actionSheetManager.confirm(t`"Êtes-vous sûrs de vouloir retirer ce contact de la catégorie "${item}" ?`,()=>{
                                                onRemoveTag(item)
                                            })
                                        }}>{item}</Tag>
                                    )
                                })}
                                {!showMore &&(
                                    <Tag color={"red"}>+{selected.categories?.length-categories.length}</Tag>
                                )}
                            </div>

                            {selected.categories?.length>3 && (
                                <div style={{
                                    position: "absolute",
                                    bottom: 0,
                                    right: 10,
                                    display:"flex",
                                    gap:5
                                }} onClick={() => setShowMore(!showMore)}>
                                    <DynamicIcon name={showMore?"arrow-up-circle":"arrow-down-circle"} color={MOBCOLORS.blue.color} size={15} style={{display:"flex",justifyContent:"center",alignItems:"center"}} />
                                    <span style={{fontSize: 12,color:MOBCOLORS.blue.color,textDecorationLine:"underline"}}>
                                        {showMore && (
                                            <Trans>Voir moins</Trans>
                                        )}
                                        {!showMore && (
                                            <Trans>Voir plus</Trans>
                                        )}
                                    </span>
                                </div>
                            )}
                        </MobCard>
                    </>
                )}
            </div>

            <ModalAddTag getRef={(ref) => modalAddTag.current = ref} onFinish={() => selected.__refreshData()}/>
        </>
    )
}

function CardInfos({selected}) {
    const modalAddField = useRef(null)
    const actionSheetManager = useActionSheet()

    const formatFieldValue = (field) => {
        if (field.type === "DATE") {
            return new Date(field.value).toLocaleDateString()
        }

        if (field.type === "DATETIME") {
            var date = new Date(field.value)
            return date.toLocaleDateString() + " à " + date.toLocaleTimeString()
        }

        return field.value
    }

    return(
        <>
            <div style={{display: "flex", flexDirection: "column", gap: 10}}>

                <div style={{display:"flex",alignSelf:"flex-end"}}>
                    <MobAddButton text={(<Trans>Ajouter une information secondaire</Trans>)} onClick={()=>modalAddField.current.show(selected.id)}/>
                </div>

                {selected.fields?.length>0 &&(
                    <>
                        <MobCard style={{boxShadow: "none", position: "relative"}}>
                            {selected.fields.map((item,index)=>{
                                return(
                                    <div key={item.id}>
                                        {index>0 &&(
                                            <Divider/>
                                        )}
                                        <div style={{display:"flex",flexDirection:"column",padding:"5px 10px"}}>
                                            <span style={{color:"#000",fontSize:13,marginBottom:5,fontWeight:item.main?"bold":"400"}}>{item.key}</span>

                                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                                                <span style={{color:MOBCOLORS.blue.color,fontSize:15}}>{formatFieldValue(item)}</span>

                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    alignItems: "center",
                                                    gap: 10
                                                }}>

                                                    {!["BOOL"].includes(item.type) && (
                                                        <Popover
                                                            content={(<Trans>{item.key} Copié</Trans>)}
                                                            trigger='click'
                                                            placement='top'
                                                            mode='dark'
                                                        >
                                                            <div style={{display: "flex", alignItems: "center", gap: 5}}
                                                                 onClick={() => {
                                                                     contactCopie(formatFieldValue(item))
                                                                 }}>
                                                                <DynamicIcon name={"copy"} color={"#000"} size={18}
                                                                             style={{
                                                                                 display: "flex",
                                                                                 justifyContent: "center",
                                                                                 alignItems: "center"
                                                                             }}/>
                                                            </div>
                                                        </Popover>
                                                    )}

                                                    <div style={{display: "flex", alignItems: "center"}}
                                                         onClick={() => {
                                                             actionSheetManager.confirm(t`Êtes-vous sûrs de vouloir supprimer cette information secondaire : "${item.key}" ?`, () => {
                                                                 selected.__onDelete(item.id, "field")
                                                             })
                                                         }}>
                                                        <DynamicIcon name={"trash-2"} color={MOBCOLORS.red.color} size={18}
                                                                     style={{
                                                                         display: "flex",
                                                                         justifyContent: "center",
                                                                         alignItems: "center"
                                                                     }}/>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                )
                            })}
                        </MobCard>
                    </>
                )}
            </div>

            <ModalAddField getRef={(ref) => modalAddField.current = ref} onFinish={() => selected.__refreshData()}/>
        </>
    )
}


function Divider() {
    return (
        <div style={{width: "100%", paddingLeft: "5%", opacity: 0.05}}>
            <div style={{width: "100%", borderTop: "1px solid #4A5568"}}/>
        </div>
    )
}
